// Конфигурация API
// export const API_BASE_URL = 'http://localhost:8000';
// export const API_BASE_URL = 'https://87.228.114.193:443';
// export const API_BASE_URL = 'https://base.ai-inference.ru';
// Получаем URL из переменных окружения или из window.ENV (для Docker)
export const API_BASE_URL = 
  (typeof window !== 'undefined' && window.ENV?.API_BASE_URL) ||
  process.env.REACT_APP_API_BASE_URL || 
  'https://back.ai-inference.ru';
  // 'http://localhost:8000';

// API для DataCore (RAG-проекты, источники, хранилища, интеграции, задачи)
export const DTCORE_API_BASE_URL = 
  (typeof window !== 'undefined' && window.ENV?.DTCORE_API_BASE_URL) ||
  process.env.REACT_APP_DTCORE_API_BASE_URL || 
  'https://api.differture.com';
  // 'http://localhost:8000';

// API для Feature Store (события, шаблонизатор, словари) — отдельный Python-микросервис
// API рекомендательной платформы (кампании, модели, обучение, выдача)
export const RECSYS_API_BASE_URL =
  (typeof window !== 'undefined' && window.ENV?.RECSYS_API_BASE_URL) ||
  process.env.REACT_APP_RECSYS_API_BASE_URL ||
  'https://rec.ai-inference.ru';
  // 'http://localhost:8080';

export const FEATURE_STORE_API_BASE_URL =
  (typeof window !== 'undefined' && window.ENV?.FEATURE_STORE_API_BASE_URL) ||
  process.env.REACT_APP_FEATURE_STORE_API_BASE_URL || 
  'https://fs.ai-inference.ru';
  // 'http://localhost:8002';

// Функция для получения заголовков авторизации
export function getAuthHeaders() {
  const token = localStorage.getItem('accessToken');
  
  if (!token) {
    return {};
  }
  
  return {
    'Authorization': `Bearer ${token}`
  };
}

// Унифицированная функция для выполнения API запросов с автоматической обработкой 401
export async function apiRequest(url, options = {}) {
  const token = localStorage.getItem('accessToken');
  
  const isFormData = options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const config = {
    ...options,
    headers,
  };
  
  try {
    const response = await fetch(url, config);
    
    // Обработка 401 - автоматический редирект на /auth
    if (response.status === 401) {
      // Удаляем токен
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user_id');
      localStorage.removeItem('email');
      
      if (typeof window !== 'undefined' && window.__showToast) {
        window.__showToast('Сессия истекла. Выполните вход заново.', 'error');
      }
      
      // Редирект на /auth
      if (typeof window !== 'undefined' && window.location) {
        window.location.href = '/auth';
      }
      
      throw new Error('Авторизация истекла');
    }

    // Обработка успешных ответов без тела
    if (response.status === 204 || response.status === 205) {
      return null; 
    }    
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const requestError = new Error(errorData.detail || errorData.message || `Ошибка: ${response.status}`);
      requestError.status = response.status;
      requestError.payload = errorData;
      throw requestError;
    }
    
    return await response.json();
  } catch (error) {
    throw error;
  }
}